<template>
    <div class="view performance-tasks">
        <app-sub-navbar parent="performance"></app-sub-navbar>
        <div class="container-fluid">
            <app-graph-filter class="text-center" @filterLoaded="getInitialData()" @filterChanged="redrawComponents()" parent="performance"></app-graph-filter>
            <div class="row mb-50">
                <div class="col-12">
                    <el-card class="box-card mt-50" v-if="loadChart" v-loading="loading">
                        <div slot="header" class="text-left">
                            <h3 class="inline">Store ranking</h3>
                            <el-radio-group @change="redrawComponents()" v-model="contractsTop5Switch" size="medium" class="vertical-center switch-right ml-5-howrly fr" v-if="$route.name.includes('contracts')">
                                <el-radio-button label="Contracts"></el-radio-button>
                                <el-radio-button label="Minimum"></el-radio-button>
                                <el-radio-button label="Budget"></el-radio-button>
                            </el-radio-group>
                            <el-select v-model="numRecords" class="fr" style="width: 120px;">
                                <el-option :value="tableData.length" label="All"></el-option>
                                <el-option :value=10 label="Top 5"></el-option>
                                <el-option :value=20 label="Top 10"></el-option>
                                <el-option :value=30 label="Top 15"></el-option>
                            </el-select>
                        </div>
                        <div v-if="tableLoaded">
                            <el-table
                                :data="getFilteredData"
                                style="width: 100%"
                                @row-click="handleRowClick"
                                :default-sort = "{prop: 'Rank', order: 'Ascending'}"
                                :row-class-name="tableRowClassName"
                                :cell-style="cellStyling"
                                :header-cell-style="columnStyling"
                            >
                                <el-table-column  v-for="col in tableHeaders"
                                                  :key="col.key"
                                                  :prop="col.prop"
                                                  :label="col.label"
                                                  :sortable=false
                                                  :formatter="formatter">
                                </el-table-column>
                            </el-table>
                        </div>
                        <!-- <app-table-component @filterChanged="redrawComponents()" ref="top5table" title="contracts" storeModule='performance' endpoint="/performance/contracts/top5" sort="Rank" order="ascending"></app-table-component> -->
                    </el-card>
                    <el-card class="box-card mt-50" v-if="loadChart" v-loading="loading">
                        <div slot="header" class="text-left">
                            <h3 class="inline" v-if="this.$store.getters['graphFilter/getZoomedinStores'].length !== 1">Contract history</h3>
                            <h3 class="inline" v-else>Contract history store {{this.$store.getters['graphFilter/getZoomedinStores'][0]}}</h3>
                            <el-radio-group @change="redrawComponents()" v-model="contractsSwitch" size="medium" class="vertical-center switch-right ml-5-howrly fr" v-if="$route.name.includes('contracts')">
                                <el-radio-button label="Total"></el-radio-button>
                                <el-radio-button label="Detail"></el-radio-button>
                            </el-radio-group>
                        </div>
                        <app-chart-component @loaded="chartLoaded" ref="chart" title="contracts" storeModule='performance' endpoint="/performance/contracts"></app-chart-component>
                    </el-card>
                    <el-card class="box-card mt-50" v-if="loadChart" v-loading="loading">
                        <div slot="header" class="text-left">
                            <h3 v-if="this.$store.getters['graphFilter/getZoomedinStores'].length !== 1">Contract details</h3>
                            <h3 v-else>Contract details store {{this.$store.getters['graphFilter/getZoomedinStores'][0]}}</h3>
                        </div>
                        <el-tabs v-model="activeName" @tab-click="handleClick">
                            <el-tab-pane label="Flow" name="flow">
                                <app-table-component ref="activetable" title="contracts" storeModule='performance' endpoint="/performance/contracts/active" sort="Hours" order="descending"></app-table-component>
                            </el-tab-pane>
                            <el-tab-pane label="Active" name="active">
                                <app-table-component ref="activetable" title="contracts" storeModule='performance' endpoint="/performance/contracts/active" sort="Hours" order="descending"></app-table-component>
                            </el-tab-pane>
                        </el-tabs>
                    </el-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SubNavbar from '../../components/SubNavbar'
import ChartComponent from '../../chart/ChartComponent'
import TableComponent from '../../table/TableComponent'
import GraphFilter from '../../components/GraphFilter'
import axios from '@/services/axios.js'
import { getTableHeaders, getHeadersWithAccessToken } from '../../functions.js'

export default {
    data () {
        return {
            activeName: 'flow',
            loadChart: false,
            tableData: [],
            tableHeaders: [],
            tableLoaded: false,
            loading: true,
            numRecords: 10
        }
    },
    computed: {
        contractsSwitch: {
            get () {
                return this.$store.state.graphFilter.contractsSwitch
            },
            set (value) {
                this.$store.commit('graphFilter/UPDATE_CONTRACTS_SWITCH', value)
                this.$emit('filterChanged')
            }
        },
        contractsTop5Switch: {
            get () {
                return this.$store.state.graphFilter.contractsTop5Switch
            },
            set (value) {
                this.$store.commit('graphFilter/UPDATE_CONTRACTS_TOP5_SWITCH', value)
                this.$emit('filterChanged')
            }
        },
        getFilteredData () {
            if (this.tableData.length > (this.numRecords - 1)) {
                let newData = []
                let data = this.sortRankData()
                for (let idx = 0; idx < (this.numRecords / 2); idx++) {
                    if (data[idx] !== undefined) {
                        newData.push(data[idx])
                    }
                }
                for (let idx = data.length - 1; idx >= (data.length - (this.numRecords / 2)); idx--) {
                    if (data[idx] !== undefined) {
                        newData.push(data[idx])
                    }
                }
                return newData // this.sortRankData(newData)
            } else {
                return this.tableData
            }
        }
    },
    components: {
        appSubNavbar: SubNavbar,
        appGraphFilter: GraphFilter,
        appChartComponent: ChartComponent,
        appTableComponent: TableComponent
    },
    methods: {
        chartLoaded () {
            this.loading = false
        },
        getInitialData () {
            this.loadChart = true
            this.getTableData()
        },
        redrawComponents (topTable = true) {
            this.loading = true
            if (topTable) {
                this.getTableData()
            }
            this.$refs.activetable.draw()
            this.$refs.chart.draw()
        },
        handleRowClick (row) {
            let store = this.$store.getters['general/getStores'].find(x => x.store_name === row.store_name)
            if (this.$store.getters['graphFilter/getZoomedinStores'].length === 1 && this.$store.getters['graphFilter/getZoomedinStores'][0] === store.store_id) {
                this.$store.commit('graphFilter/RESET_ZOOMED_STORES')
            } else {
                this.$store.commit('graphFilter/UPDATE_ZOOMED_STORES', [store])
            }
            this.redrawComponents(false)
        },
        sortRankData (data = this.tableData) {
            let newData = []
            // Sort the list
            if (this.$store.state.graphFilter.contractsTop5Switch === 'Contracts') {
                newData = data.sort((a, b) => (a['contract_hours'] < b['contract_hours']) ? 1 : -1)
            } else if (this.$store.state.graphFilter.contractsTop5Switch === 'Minimum') {
                newData = data.sort((a, b) => (a['min_hours_perc'] < b['min_hours_perc']) ? 1 : -1)
            } else {
                newData = data.sort((a, b) => (a['budget_hours_perc'] < b['budget_hours_perc']) ? 1 : -1)
            }
            // Set the rank
            for (let i = 0; i < newData.length; i++) {
                newData[i]['Rank'] = parseInt(i + 1)
            }
            return newData
        },
        getTableData () {
            this.tableLoaded = false
            axios.post(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_DATA_API_BASE_URL_DEV : process.env.VUE_APP_DATA_API_BASE_URL) + '/at' + '/performance/contracts/top5', {
                'store_id': this.$store.getters['graphFilter/getStoreIds'],
                'format': 'aod'
            }, { headers: getHeadersWithAccessToken() })
                .then(response => {
                    this.tableData = this.sortRankData(response.data.data)
                    this.tableHeaders = getTableHeaders(response.data.columns)

                    // Add rank and swap for ordering
                    let headersCopy = JSON.parse(JSON.stringify(this.tableHeaders))
                    this.tableHeaders = []
                    this.tableHeaders.push({ 'key': 'Rank', 'prop': 'Rank', 'label': 'Rank' })
                    for (let i = 0; i < headersCopy.length; i++) {
                        this.tableHeaders[i + 1] = headersCopy[i]
                    }
                    this.tableLoaded = true
                })
                .catch(error => {
                    console.log(error)
                })
        },
        tableRowClassName ({ row, rowIndex }) {
            let store = this.$store.getters['general/getStores'].find(x => x.store_name === row.store_name)
            if (store.store_id === this.$store.getters['graphFilter/getZoomedinStores'][0] && this.$store.getters['graphFilter/getZoomedinStores'].length === 1) {
                return 'highlight-row'
            }
        },
        formatter (row, column) {
            if (column.property === 'Rate' || column.property === 'Costs') {
                return '€' + row[column.property].toLocaleString('en-EN')
            } else if (column.property.includes('perc')) {
                return row[column.property] + '%'
            } else {
                return row[column.property].toLocaleString('en-EN')
            }
        },
        cellStyling (param) {
            const { column, row } = param
            const mapping = { 'Contracts': 'contract_hours', 'Minimum': 'min_hours_perc', 'Budget': 'budget_hours_perc' }
            if (column.property === 'Rank' && row[column.property] !== null) {
                if (this.tableData.length === 1) {
                    return { }
                } else if (row['Rank'] > (this.getFilteredData.length / 2)) {
                    return { color: '#de1738', fontWeight: '800' }
                } else {
                    return { color: '#2e8b57', fontWeight: '800' }
                }
            }
            if (column.property === mapping[this.$store.state.graphFilter.contractsTop5Switch] && row[column.property] !== null) {
                return { fontWeight: '800' }
            }
        },
        columnStyling (param) {
            const { column } = param
            const mapping = { 'Contracts': 'contract_hours', 'Minimum': 'min_hours_perc', 'Budget': 'budget_hours_perc' }
            if (column.property === mapping[this.$store.state.graphFilter.contractsTop5Switch]) {
                return { fontWeight: '800', color: '#606266' }
            }
        }
    },
    created () {
    }
}
</script>
